import React, { useEffect, useState } from 'react';

import {
    Badge,
    Button,
    ButtonGroup,
    Card,
    Container,
    Dropdown,
    Form,
    Image,
    Modal,
    Spinner,
    Stack,
    Table,
} from 'react-bootstrap';
import edit from '../../Assets/Img/edit.png';
import view from '../../Assets/Img/eye.png';
import NoDraft from '../../Assets/Img/noDrafts.png';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { Eye, File, Pencil, Plus } from 'lucide-react';
import LoadingComponent from '../LoadingComponent';
import { useTranslation } from 'react-i18next';
import { formatDate, frenchFormatDate, toCamelCase } from '../../helper';
import { useOrderExportMutation, useOrdersListMutation } from './ordersApi';
import ChangeStatus from './changeStatus';
import * as XLSX from 'xlsx';
import { setSecureItem, getSecureItem,removeSecureItem } from "../../utils/secureStorage";
const OrdersList = () => {
    const { t } = useTranslation();
    const { state } = useLocation();

    const user = getSecureItem('UserData');
    const navigate = useNavigate();
    const ordersData = useSelector((state) => state.orders);
    const [idSum, setIdSum] = useState([]);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [loading, setLoading] = useState(true);
    const config = {
        patientEmail: '',
        status: state?.status,
        search: state?.eyeData?.patientEmail,
        pageNumber: 1,
        pageSize: 50,
        startDate: '',
        endDate: '',
    };

    const [pageCount, setPageCount] = useState(1);
    //const [ordersListConfig, setOrdersListConfig] = useState(config);
    const [ordersListConfig, setOrdersListConfig] = useState(() => {
        const saved = getSecureItem("orderListConfigCopy") || config;
        return saved ? saved : config;
    });

    const [ordersList] = useOrdersListMutation();
    const [exportOrder] = useOrderExportMutation();

    useEffect(() => {
        if (loading) {
            ordersList({
                ...ordersListConfig,
                patientEmail: state?.email ? state.email : '',
            }).then((data) => {
                setLoading(false);
            });
        }
    }, [loading]);

    const handleFilterChange = (count = 1) => {
        setSecureItem("orderListConfigCopy", ordersListConfig);
        setPageCount(count);
        setOrdersListConfig({ ...ordersListConfig, pageNumber: count });
        setLoading(true);
    };

    const handleChange = (e) => {
        setOrdersListConfig((prevValues) => {
            return {
                ...prevValues,
                [e.target.name]: e.target.value,
            };
        });
    };

    const sortOrdersByInfoOrderPair = (orders) => {
        return orders
            .map((order) => {
                return {
                    ...order,
                    OrderPairNo: order.infoOrderPair || '0', // Defaulting to "0" if not present
                };
            })
            .sort((a, b) => {
                const pairA = parseInt(a.OrderPairNo, 10);
                const pairB = parseInt(b.OrderPairNo, 10);
                return pairA - pairB;
            });
    };

    const handleIdSum = (checked, id) => {
        console.log(checked, id, 'checked, id');
        let array = idSum;
        const index = array.indexOf(id);
        if (checked) {
            // Add ID if not already in the array
            if (index === -1) {
                array.push(id);
            }
        } else {
            // Remove ID if it exists in the array
            if (index !== -1) {
                array.splice(index, 1);
            }
        }
        setIdSum([...array]);
    };

    const exportHandle = async () => {
        setButtonLoading(true);
        try {
            let { data } = await exportOrder(state?.status || '');
            const ws = XLSX.utils.json_to_sheet(data);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Order');

            const excelBuffer = XLSX.write(wb, {
                bookType: 'xlsx',
                type: 'array',
            });
            const blobData = new Blob([excelBuffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });

            const url = URL.createObjectURL(blobData);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Order_Data.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            // window.open(data?.prescriptionFileFullName, '_blank', 'noopener,noreferrer');
            setButtonLoading(false);
        } catch (error) { }
    };

    if (loading) {
        return <LoadingComponent />;
    }

    return (
        <>
            <Container fluid className="list_wrapper">
                <Stack direction="horizontal" gap={3} className="mb-3">
                    <div className="ms-auto d-flex gap-3">
                        {['ADMIN', 'BACKOFFICE'].includes(user?.userType) ? (
                            <>
                                {/* {state?.status ? ( */}
                                <Button
                                    onClick={exportHandle}
                                    disabled={buttonLoading}
                                >
                                    {buttonLoading && (
                                        <Spinner
                                            animation="border"
                                            role="status"
                                            size="sm"
                                        >
                                            <span className="visually-hidden">
                                                Loading...
                                            </span>
                                        </Spinner>
                                    )}{' '}
                                    Exporter des données (Excel)
                                </Button>
                                {/* ) : null} */}
                            </>
                        ) : null}
                        {['ADMIN', 'BACKOFFICE'].includes(user?.userType) ? (
                            <ChangeStatus
                                idSum={idSum}
                                setLoading={setLoading}
                                onClearSelection={() => setIdSum([])}
                            />
                        ) : null}
                        {state?.addOrder && (
                            <Button
                                variant="primary"
                                onClick={() =>
                                    navigate('/order/add', {
                                        state: { eyeData: state?.eyeData },
                                    })
                                }
                            >
                                <Plus width={14} height={14} /> {t('orderAdd')}
                            </Button>
                        )}
                    </div>
                </Stack>
                <Card>
                    <Card.Header>
                        <Stack
                            direction="horizontal"
                            gap={3}
                            className="listing_filters"
                        >
                            <Stack direction="horizontal" gap={3}>
                                <Form.Control
                                    type="text"
                                    onChange={handleChange}
                                    value={ordersListConfig.search}
                                    name="search"
                                    placeholder={t('search')}
                                />
                                <Form.Control
                                    type="date"
                                    onChange={handleChange}
                                    name="startDate"
                                />
                                <Form.Control
                                    type="date"
                                    onChange={handleChange}
                                    name="endDate"
                                />
                                <Button
                                    variant="secondary"
                                    onClick={() => handleFilterChange()}
                                >
                                    {t('search')}
                                </Button>
                            </Stack>
                            <div className="ms-auto">
                                <Button
                                    variant="link"
                                    className=""
                                    onClick={() => {
                                        removeSecureItem("orderListConfigCopy");
                                        setOrdersListConfig(config);
                                        setLoading(true);
                                    }}
                                >
                                    {t('resetFilters')}
                                </Button>
                            </div>
                        </Stack>
                    </Card.Header>

                    <Card.Body className="table_outer">
                        <Table>
                            <thead>
                                <tr>
                                    <th>
                                        <input type="checkbox" />
                                    </th>
                                    <th>N° Test</th>
                                    <th>{t('optician')}</th>
                                    <th># {t('commandes')}</th>
                                    <th>{t('pdv')}</th>
                                    <th>{t('patient')}</th>
                                    <th>{t('createdOn')}</th>
                                    <th>{t('status')}</th>
                                    <th className="text-end">{t('actions')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ordersData?.listData?.orderCombinedDatas &&
                                    ordersData?.listData?.orderCombinedDatas
                                        .length > 0 ? (
                                    ordersData?.listData?.orderCombinedDatas.map(
                                        (order, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e) => {
                                                            handleIdSum(
                                                                e.target
                                                                    .checked,
                                                                order.orderCombinedId
                                                            );
                                                        }}
                                                    />
                                                </td>
                                                <td>{order.testUniqueCode}</td>
                                                <td>{order.opticianName}</td>
                                                <td>{order.orderCount}</td>
                                                <td>{order.posName}</td>
                                                <td>{order.patientName}</td>
                                                <td>
                                                    {frenchFormatDate(
                                                        order.orderCreated
                                                    )}
                                                </td>
                                                <td>
                                                    <Badge className="status_badge">
                                                        {order.status === 'ToBeOrdered'
                                                            ? t('toBeOrdered')
                                                            : order.status === 'Pending'
                                                                ? t(toCamelCase(order.status))
                                                                : order.status}
                                                    </Badge>
                                                </td>
                                                <td>
                                                    <Stack
                                                        direction="horizontal"
                                                        gap={1}
                                                    >
                                                        <div className="ms-auto">
                                                            <ButtonGroup>
                                                                <Button
                                                                    variant="light"
                                                                    onClick={() =>
                                                                        navigate(
                                                                            '/order/view',
                                                                            {
                                                                                state: {
                                                                                    orderData:
                                                                                        sortOrdersByInfoOrderPair(
                                                                                            order.orderModelList
                                                                                        ),
                                                                                    view: 'view',
                                                                                },
                                                                            }
                                                                        )
                                                                    }
                                                                >
                                                                    <Stack
                                                                        direction="horizontal"
                                                                        gap={1}
                                                                    >
                                                                        <Eye
                                                                            width={
                                                                                16
                                                                            }
                                                                        />
                                                                    </Stack>
                                                                </Button>
                                                                {(
                                                                    (['ADMIN', 'BACKOFFICE', 'OPTICIAN'].includes(user?.userType) &&
                                                                        order.status === 'Devis' &&
                                                                        order.status !== 'Pending'
                                                                    ) ||

                                                                    (['ADMIN', 'BACKOFFICE', 'OPTICIAN'].includes(user?.userType) &&
                                                                        order.status === 'Pending' &&
                                                                        order.status !== 'Devis')
                                                                ) ? (
                                                                    <Button
                                                                        variant="light"
                                                                        onClick={() =>
                                                                            navigate('/order/edit', {
                                                                                state: {
                                                                                    orderData: sortOrdersByInfoOrderPair(order.orderModelList),
                                                                                    view: 'edit',
                                                                                },
                                                                            })
                                                                        }
                                                                    >
                                                                        <Stack direction="horizontal" gap={1}>
                                                                            <Pencil width={16} />
                                                                        </Stack>
                                                                    </Button>
                                                                ) : null}

                                                            </ButtonGroup>
                                                        </div>
                                                    </Stack>
                                                </td>
                                            </tr>
                                        )
                                    )
                                ) : (
                                    <tr>
                                        <td colSpan={9}>
                                            <Stack
                                                gap={2}
                                                className="mt-5 mb-5 mx-auto text-center"
                                            >
                                                <Image
                                                    src={NoDraft}
                                                    width={88}
                                                    className="mx-auto"
                                                />
                                                <h4>{t('noDataAvailable')}</h4>
                                                {/* <p>{t("YouHaven'tCreatedAnyDraftYet")}</p> */}
                                            </Stack>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </Card.Body>
                    <Card.Footer>
                        <Stack direction="horizontal" gap={3}>
                            <div className="ms-auto">
                                <Stack direction="horizontal" gap={3}>
                                    {/* Page numbers */}
                                    <span>
                                        Page {pageCount} of{" "}
                                        {Math.ceil(
                                            ordersData?.listData?.totalItems /
                                            ordersListConfig.pageSize
                                        )}
                                    </span>

                                    {/* Showing data range */}
                                    <span>
                                        Affichage de{" "}
                                        {(pageCount - 1) * ordersListConfig.pageSize + 1}–
                                        {Math.min(
                                            pageCount * ordersListConfig.pageSize,
                                            ordersData?.listData?.totalItems
                                        )}{" "}
                                        of {ordersData?.listData?.totalItems}
                                    </span>

                                    {/* Prev button */}
                                    <Button
                                        variant="secondary"
                                        className="paginationBar_rightSide_prev"
                                        disabled={pageCount <= 1}
                                        onClick={() => handleFilterChange(pageCount - 1)}
                                    >
                                        {t("prev")}
                                    </Button>

                                    {/* Next button */}
                                    <Button
                                        variant="secondary"
                                        className="paginationBar_rightSide_next"
                                        disabled={
                                            pageCount >=
                                            Math.ceil(
                                                ordersData?.listData?.totalItems /
                                                ordersListConfig.pageSize
                                            )
                                        }
                                        onClick={() => handleFilterChange(pageCount + 1)}
                                    >
                                        {t("next")}
                                    </Button>
                                </Stack>
                            </div>
                        </Stack>
                    </Card.Footer>

                </Card>
            </Container>
        </>
    );
};

export default OrdersList;
